import { render, staticRenderFns } from "./UcEmployeeCard.yaml?vue&type=template&id=31198fc4&component"
import script from "./UcEmployeeCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcEmployeeCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports